export type OnlyOne<T, U = T> = {
  [K in keyof T]: Pick<T, K> & Partial<Record<Exclude<keyof U, K>, never>>;
}[keyof T];

export type WithRequired<T, K extends keyof T> = T & Required<Pick<T, K>>;

export type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

export function isNumber(value: unknown): value is number {
  return typeof value === 'number';
}

export function getFirstMonth(months: number[]): number {
  if (months?.length > 12) {
    return months[months?.length - 12];
  }
  return months[0];
}
